import * as Sentry from '@sentry/browser'
import React from 'react'

export interface ErrorBoundaryState {
    eventId: string
    hasError: boolean
}

if (process.env.SENTRY_DSN) {
    Sentry.init({ dsn: process.env.SENTRY_DSN })
}
export default class ErrorBoundary extends React.PureComponent<
    React.PropsWithChildren,
    ErrorBoundaryState
> {
    constructor(props) {
        super(props)
        this.state = { eventId: null, hasError: null }
    }

    static getDerivedStateFromError() {
        return { hasError: true }
    }

    componentDidCatch(error, errorInfo) {
        if (process.env.NODE_ENV === 'production' && !!process.env.SENTRY_DSN) {
            Sentry.withScope((scope) => {
                scope.setExtras(errorInfo)
                const eventId = Sentry.captureException(error)
                this.setState({ eventId })
            })
        }
    }

    render() {
        return this.props.children
    }
}
